<template>
    <transition name="slide-up">
        <div
            v-if="clips.length || finished"
            class="fixed bottom-4 right-4 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 w-80 overflow-hidden"
        >
            <!-- header -->
            <div class="bg-primary text-white px-4 py-2 flex items-center justify-between">
                <div class="flex items-center gap-2 text-sm font-semibold">
                    <svg v-if="!finished" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                    </svg>
                    <ion-icon v-else name="checkmark-circle-outline"></ion-icon>
                    {{ finished ? 'AI Analysis Complete' : 'AI Analysis Running…' }}
                </div>
                <button @click="dismiss" class="text-white opacity-70 hover:opacity-100 text-lg leading-none">×</button>
            </div>

            <!-- clip list -->
            <div class="max-h-48 overflow-y-auto">
                <div
                    v-for="clip in clips"
                    :key="clip.clip_id"
                    class="flex items-center gap-2 px-4 py-2 border-b border-gray-100 text-sm text-gray-700"
                >
                    <ion-icon name="film-outline" class="text-primary flex-shrink-0"></ion-icon>
                    <span>{{ clip.name }}</span>
                    <span class="ml-auto text-xs text-green-600 font-medium">Added</span>
                </div>
                <div v-if="!clips.length && !finished" class="px-4 py-3 text-sm text-gray-400 text-center">
                    Waiting for first clip…
                </div>
            </div>

            <!-- footer -->
            <div class="px-4 py-2 bg-gray-50 flex items-center justify-between">
                <span class="text-xs text-gray-500">{{ clips.length }} clip{{ clips.length !== 1 ? 's' : '' }} added</span>
                <button
                    v-if="finished"
                    @click="reload"
                    class="text-xs bg-primary text-white px-3 py-1 rounded-lg hover:opacity-90"
                >
                    Refresh Page
                </button>
                <span v-else class="text-xs text-gray-400 italic">refreshes when done</span>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import emitter from 'tiny-emitter/instance';

const clips    = ref([]);
const finished = ref(false);
const visible  = ref(false);

function onClipCreated(clip) {
    clips.value.push(clip);
    visible.value = true;
}

function onAnalysisComplete() {
    finished.value = true;
}

function dismiss() {
    clips.value    = [];
    finished.value = false;
    visible.value  = false;
}

function reload() {
    window.location.reload();
}

onMounted(() => {
    emitter.on('ai-clip-created', onClipCreated);
    emitter.on('ai-analysis-complete', onAnalysisComplete);
});

onBeforeUnmount(() => {
    emitter.off('ai-clip-created', onClipCreated);
    emitter.off('ai-analysis-complete', onAnalysisComplete);
});
</script>

<style scoped>
.slide-up-enter-active, .slide-up-leave-active { transition: transform .3s ease, opacity .3s ease; }
.slide-up-enter-from, .slide-up-leave-to { transform: translateY(20px); opacity: 0; }
</style>
